import { useCallback } from "react"
import SearchFactor from "components/search-factor"
import type { FactorRule } from "components/search-factor/types"
import { useRules } from "../hooks/use-rules"
import type { FactorRulesSearchProps } from "../types"

const FACTOR_VALUE_LABEL = "Current portfolio value"

export default function FactorRulesSearch({
  positionSet,
  onRuleSelected,
  ruleDisplayType,
  existingRules,
}: FactorRulesSearchProps) {
  const [factorRules] = useRules(positionSet, ruleDisplayType, existingRules)

  const handleOnClick = useCallback((item: FactorRule) => {
    onRuleSelected(item, ruleDisplayType)
  }, [onRuleSelected, ruleDisplayType])

  return (
    <SearchFactor
      selectItem={handleOnClick}
      factorValueLabel={FACTOR_VALUE_LABEL}
      factors={factorRules}
    />
  )
}
